import * as React from "react";

import { Context } from "../Context";
import { ExperienceContent } from "./ExperienceContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

export function Experience() {
  const context: any = React.useContext(Context);
  const experience = context.data.experience;
  if (!experience.items) {
    return null;
  }
  return (
    <div id="experience" className="grid-container">
      <h2>Experience &amp; Background</h2>
      {Object.keys(experience.items).map(experienceHeader => {
        return (
          <div key={experienceHeader} className="grid-x">
            <div className="cell">
              <h3>
                <button className="hide-button" onClick={() => context.toggleHidden(experienceHeader)}>
                  {context.hidden[experienceHeader] && <FontAwesomeIcon icon={faChevronUp} />}
                  {!context.hidden[experienceHeader] && <FontAwesomeIcon icon={faChevronDown} />}
                </button>
                {experienceHeader}
              </h3>
              {!context.hidden[experienceHeader] && <ExperienceContent items={experience.items[experienceHeader]} />}
            </div>
          </div>
        );
      })}
    </div>
  );
}
